import { shipmentService } from '../services/shipmentService.js'
import { printPdfBlob, parseBlobErrorMessage } from './printPdfBlob.js'
import Alert from '../components/common/Alert.js'

const QR_PRINT_ROLES = ['System Admin', 'Admin', 'Accountant', 'Hub Admin']

export function canPrintShipmentQr(user) {
  return QR_PRINT_ROLES.includes(user?.role)
}

export async function printShipmentQrCode(shipmentId, { onClose } = {}) {
  try {
    if (onClose) onClose()
    const response = await shipmentService.getQRCode(shipmentId)
    const result = await printPdfBlob(response.data, `QR_Code_${shipmentId}.pdf`)
    if (result.method === 'download') {
      Alert.success('Popup blocked — QR PDF downloaded. Open the file to print.')
    }
  } catch (error) {
    Alert.error(await parseBlobErrorMessage(error, 'Failed to print QR code'))
  }
}

export async function downloadShipmentQrCodesBulk(shipmentIds, filename = 'shipment_qr_codes.pdf') {
  const ids = (shipmentIds || []).filter(Boolean)
  if (!ids.length) {
    Alert.error('No shipments found for QR download')
    return
  }
  try {
    const response = await shipmentService.bulkDownloadQRCodes(ids)
    const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
    window.URL.revokeObjectURL(url)
    Alert.success('Shipment QR codes downloaded')
  } catch (error) {
    Alert.error(await parseBlobErrorMessage(error, 'Failed to download shipment QR codes'))
  }
}
